import type { Post, PostFormType, PostListItem } from '@/types'

import Model from './Model'

type FormType = PostFormType
type ListItemType = PostListItem
type SingleType = Post

type Type = FormType | ListItemType | SingleType

export default class PostModel extends Model {
  static model: FormType = {
    id: null,

    name: null,
    date: null,
    tag: null,
    url: null,
    teaser: null,

    active: false,
  }

  static get() {
    return super.get() as FormType
  }

  static prepareWith<T = Type>(model: T) {
    return super.prepareWith(model) as FormType
  }

  static reset<F = Type, S = Type>(formModel: F, snapshot?: S) {
    return super.reset(formModel, snapshot) as F & S
  }

  static mergeTogether<T = Type>(model: T) {
    return super.mergeTogether(model) as Type
  }

  static mergeTogetherAndCutExcess<T = Type>(model: T) {
    return super.mergeTogetherAndCutExcess(model) as FormType
  }

  static onlyModelKeysDiff<T = Type>(snapshot: T, formModel: T) {
    return super.onlyModelKeysDiff(snapshot, formModel) as Partial<FormType>
  }
}
